import { IconProps } from "../../../Types/IconProps";

function MinusIcon (props: IconProps) {
  return (
    <svg className={props.className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 10L1 6L15 6V10L1 10Z" />
    </svg>
  );
}

export { MinusIcon }